import React from "react";
import { PhoneIncoming, Sparkles, ClipboardList, CalendarCheck, UserRoundCog, RefreshCw, LineChart, ArrowRight } from "lucide-react";
import { useI18n } from "../../i18n/I18nContext";

const icons = [PhoneIncoming, Sparkles, ClipboardList, CalendarCheck, UserRoundCog, RefreshCw, LineChart];
const slugs = ["missed-call-recovery", "ai-customer-replies", "lead-intake", "booking-flow", "human-takeover", "follow-up-automation", "reporting-dashboard"];

export const ServicesGrid = ({ withHeader = true }) => {
  const { t } = useI18n();
  return (
    <section className={withHeader ? "py-24 lg:py-32" : "pt-12 lg:pt-16 pb-20 lg:pb-24"} data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {withHeader && (
          <div className="max-w-2xl mb-12">
            <div className="eyebrow mb-3">{t.services.eyebrow}</div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">{t.services.title}</h2>
          </div>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {t.services.list.map((s, i) => {
            const Icon = icons[i] || Sparkles;
            const isFeatured = i === 0;
            return (
              <div
                key={i}
                id={slugs[i]}
                className={`glass rounded-2xl p-7 group scroll-mt-36 hover:border-white/20 hover:-translate-y-0.5 transition-all ${isFeatured ? "md:col-span-2 lg:row-span-1 bg-gradient-to-br from-blue-500/10 to-transparent border-blue-400/20" : ""}`}
                data-testid={`service-card-${i}`}
              >
                <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-5 ${isFeatured ? "bg-blue-600 text-white glow-blue" : "bg-white/5 text-cyan-300 border border-white/10"}`}>
                  <Icon size={20} />
                </div>
                <h3 className={`font-display font-bold text-white ${isFeatured ? "text-2xl sm:text-3xl" : "text-xl"}`}>{s.title}</h3>
                <p className="text-slate-400 mt-3 leading-relaxed text-sm">{s.desc}</p>
                {isFeatured && (
                  <div className="mt-6 inline-flex items-center gap-2 text-cyan-300 text-sm font-medium">
                    {t.services.mostRequested} <ArrowRight size={14} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
